<template>
	<div>
		<navpage ref="navPage" :middle="true" pagename="profiles" :displayDates="false" :displayFilters="true"></navpage>
		<div id="content-page">
			<div class="row dynvibeSearch">
				<div class="row dynvibeRow">
					<middlefilter
						ref="middlefilter"
						@changefilters="updateProfile($event)"
						@addnewauthor="addAuthor"
						v-bind="{ profilesPage: true }"
					></middlefilter>
				</div>
			</div>
			<div class="row dynvibeRow">
				<div class="col-lg-12">
					<div class="dynvibeBox">
						<div class="col-lg-12 dynvibeTitleBox">
							<h2>Profiles</h2>
						</div>
						<div class="col-lg-12">
							<profileslist ref="profileslist" @editprofile="editProfile($event)" v-bind="$data"></profileslist>
						</div>
					</div>
				</div>
			</div>
			<div>
				<keep-alive>
					<profilesedit ref="profilesedit" @reloadlist="reloadProfileList()"></profilesedit>
				</keep-alive>
			</div>
		</div>
		<slot name="page"></slot>
		<profilesgraph ref="profilesgraph" v-bind="$data"></profilesgraph>
	</div>
</template>

<script>
import navpage from "@/components/globalVue/Nav.vue";
import middlefilter from "@/components/globalVue/MiddleFilter.vue";
import profilesedit from "@/components/profiles/ProfilesEdit.vue";
import profileslist from "@/components/profiles/ProfilesList.vue";
import profilesgraph from "@/components/profiles/ProfilesGraph.vue";

export default {
	props: {},
	name: "profilespage",
	components: {
		navpage: navpage,
		middlefilter: middlefilter,
		profilesedit: profilesedit,
		profileslist: profileslist,
		profilesgraph: profilesgraph,
	},
	data() {
		return {
			search: "",
			panel: "",
			segment: "",
			sort: {
				field: "date",
				order: "desc",
			},
			size: 20,
			impact_score_min: "",
			impact_score_max: "",
			checkbox_all: false,
			is_checked: [],
			no_segment: false,
			identical_checkbox_all: 0, // To watch only one data
		};
	},
	mounted: function () {},
	methods: {
		updateProfile(val) {
			this.search = val.search.toLowerCase();
			this.panel = val.panel;
			this.segment = val.segment;
			this.sort = val.sort;
			this.size = parseInt(val.size);
			this.impact_score_min = val.impact_score_min;
			this.impact_score_max = val.impact_score_max;

			if (val.checkbox_all != this.checkbox_all) {
				this.checkbox_all = val.checkbox_all;
				this.is_checked = [];
				this.no_segment = false;
			} else {
				this.is_checked = val.is_checked;
				this.no_segment = val.no_segment;
				this.identical_checkbox_all = Math.random(); // If this data is modified, another data is also
			}
		},
		editProfile(val) {
			this.$refs.profilesedit.loadData(val, true);
		},
		addAuthor() {
			this.$refs.profilesedit.addNewAuthor();
		},
		confirmUpdatedAuthor(message) {
			this.confirmMessage = message;
			this.$refs.author.open();
		},
		reloadProfileList() {
			setTimeout(function () {
				this.$refs.profileslist.loadComponent();
			}, 3000);
		},
	},
};
</script>

<style scoped></style>
